import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaPagosPorEventoRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaPagosPorEventoRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultaPagosPorEventoRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultaPagosPorEventoRest_Entrada {
  TipoConsulta: string;
  BanderaHD: string;
  Paquete: string;
  Country: string;
  TipoCuenta: string;
}

export function builtConsultaPagosPorEventoRestEntrada(
  p_TipoConsulta: string,
  p_BanderaHD: string,
  p_Paquete: string,
  p_Country: string,
  p_TipoCuenta: string
) {
  var retorno: ConsultaPagosPorEventoRest_Entrada = {
    TipoConsulta: p_TipoConsulta,
    BanderaHD: p_BanderaHD,
    Paquete: p_Paquete,
    Country: p_Country,
    TipoCuenta: p_TipoCuenta,
  };

  return retorno;
}

//SALIDA

export interface ConsultaPagosPorEventoRest_Salida {
  result: string;
  result_code: string;
  PPE: Ppe[];
}

export interface Ppe {
  CHANNEL: string;
  CHANNEL_DISPLAY: string;
  DISPLAY_VALUE: string;
  SINOPSIS_VALUE: string;
  IMG: string;
  PRICE: string;
  IDIOMA: string;
  SUBTITULOS: string;
  TITULO: string;
  MENSAJE: string;
}

export type ConsultaPagosPorEventoRest_Respuesta =
  ConsultaPagosPorEventoRest_Salida;
